import { SvgIcon, type SxProps, type Theme } from '@mui/material';
import React from 'react';
import Alt from '../../assets/Alt.svg';
import GrayAlt from '../../assets/GrayAlt.svg';

type Props = {
    gray?: boolean;
    sx?: SxProps<Theme>
}

export default function AltIcon({ gray, sx = []}: Props) {
    if (gray) return (
        <SvgIcon sx={[ ...(Array.isArray(sx) ? sx : [sx]) ]} color='disabled' component={GrayAlt} inheritViewBox />
    )

    return (
        <SvgIcon sx={[ ...(Array.isArray(sx) ? sx : [sx]) ]} component={Alt} inheritViewBox />
    )
}